export default __webpack_public_path__ + "static/media/ellipse-green.89bdf248.svg";